<template>
  <div class="py-4 container-fluid">
    <div class="col-12">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: "productTraceIndex",
  components: {
  },
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>
